<template>
  <div
    class="avatar"
    :style="'background-image:url('+avatar+')'"
  />
</template>

<script>
export default {
  props: ['img'],
  data () {
    return {
      avatar: 'https://xiaoxiangs.laway.cn/media/up/2018/8/14/412b79bcd7f464285cf4e11970a1173d.png'
    }
  },
  mounted () {
    const config = this.$root.xiaoconfig
    if (config && config.pc_avatar) {
      this.avatar = `https://xiaoxiangs.laway.cn${config.pc_avatar}`
    }
    if (this.img) {
      this.avatar = this.img
    }
  }
}
</script>
